<template>
  <div id="app" class="game-shell">
    <div class="game-main">
      <div class="container">
        <br>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column is-four-fifths">
            <div class="tabs is-centered">
              <ul>
                <li v-bind:class="this.$route.name == 'root' ? 'is-active' : ''"><router-link :to="{name: 'root'}">
                  Домой
                </router-link></li>
                <li v-bind:class="this.$route.path.startsWith('/atlas') ? 'is-active' : ''"><router-link :to="{name: 'atlas'}">Атлас</router-link></li>
                <li v-bind:class="this.$route.path.startsWith('/economica') ? 'is-active' : ''"><router-link :to="{name: 'economica'}">Экономика</router-link></li>
                <li v-bind:class="this.$route.path.startsWith('/adminstraion') ? 'is-active' : ''"><router-link :to="{name: 'adminstraion'}">Администрация</router-link></li>
                <li v-bind:class="this.$route.path.startsWith('/politica') ? 'is-active' : ''"><router-link :to="{name: 'politica'}">Политика</router-link></li>
                <li v-bind:class="this.$route.path.startsWith('/ship') ? 'is-active' : ''"><router-link :to="{name: 'ship'}">Корабль</router-link></li>
                <li v-bind:class="this.$route.path.startsWith('/profile') ? 'is-active' : ''">
                  <router-link :to="{name: 'profile'}">Профиль</router-link>
                </li>
              </ul>
            </div>
            <div class="tabs is-centered is-small" v-if="this.$route.path.startsWith('/economica')">
              <ul>
                <li>
                  <li v-bind:class="this.$route.name == 'economica' ? 'is-active' : ''"><router-link :to="{name: 'economica'}">Сводка</router-link></li>
                  <li v-bind:class="this.$route.name == 'markets' ? 'is-active' : ''"><router-link :to="{name: 'markets'}">Рынки</router-link></li>
                  <li v-bind:class="this.$route.name == 'productions' ? 'is-active' : ''"><router-link :to="{name: 'productions'}">Производства</router-link></li>
                </li>
              </ul>
            </div>
            <div class="tabs is-centered is-small" v-if="this.$route.path.startsWith('/adminstraion')">
              <ul>
                <li>
                  <li v-bind:class="this.$route.name == 'adminstraion' ? 'is-active' : ''"><router-link :to="{name: 'adminstraion'}">Сводка</router-link></li>
                  <li v-bind:class="this.$route.name == 'news' ? 'is-active' : ''"><router-link :to="{name: 'news'}">Новости</router-link></li>
                  <li v-bind:class="this.$route.name == 'quests' ? 'is-active' : ''"><router-link :to="{name: 'quests'}">Квесты</router-link></li>
                </li>
              </ul>
            </div>
            <div class="tabs is-centered is-small" v-if="this.$route.path.startsWith('/politica')">
              <ul>
                <li>
                  <li v-bind:class="this.$route.name == 'politica' ? 'is-active' : ''"><router-link :to="{name: 'politica'}">Сводка</router-link></li>
                  <li v-bind:class="this.$route.name == 'clans' ? 'is-active' : ''"><router-link :to="{name: 'clans'}">Кланы</router-link></li>
                  <li v-bind:class="this.$route.name == 'myclan' ? 'is-active' : ''"><router-link :to="{name: 'myclan'}">Мой клан</router-link></li>
                </li>
              </ul>
            </div>
            <div class="tabs is-centered is-small" v-if="this.$route.path.startsWith('/atlas')">
              <ul>
                <li v-bind:class="this.$route.name == 'orbit' ? 'is-active' : ''"><router-link :to="{name: 'orbit'}">Орбита</router-link></li>
                <li v-bind:class="this.$route.name == 'surface' ? 'is-active' : ''"><router-link :to="{name: 'surface'}">Поверхность</router-link></li>
                <li v-bind:class="this.$route.name == 'solarSystem' ? 'is-active' : ''"><router-link :to="{name: 'solarSystem'}">Система</router-link></li>
                <li v-bind:class="this.$route.name == 'galaxy' ? 'is-active' : ''"><router-link :to="{name: 'galaxy'}">Галактика</router-link></li>
              </ul>
            </div>
            <div class="tabs is-centered is-small" v-if="this.$route.path.startsWith('/ship')">
              <ul>
                <li v-bind:class="this.$route.name == 'ship' ? 'is-active' : ''"><router-link :to="{name: 'ship'}">Мой корабль</router-link></li>
                <li v-bind:class="this.$route.name == 'hangar' ? 'is-active' : ''"><router-link :to="{name: 'hangar'}">Ангар</router-link></li>
                <li v-bind:class="this.$route.name == 'shipyard' ? 'is-active' : ''"><router-link :to="{name: 'shipyard'}">Верфь</router-link></li>
              </ul>
            </div>
            <div class="tabs is-centered is-small" v-if="this.$route.path.startsWith('/profile')">
              <ul>
                <li v-bind:class="this.$route.name == 'profile' ? 'is-active' : ''"><router-link :to="{name: 'profile'}">Основные данные</router-link></li>
                <li v-bind:class="this.$route.name == 'skills' ? 'is-active' : ''"><router-link :to="{name: 'skills'}">Умения</router-link></li>
                <li v-bind:class="this.$route.name == 'learning' ? 'is-active' : ''"><router-link :to="{name: 'learning'}">Обучение</router-link></li>
                <li v-bind:class="this.$route.name == 'awards' ? 'is-active' : ''"><router-link :to="{name: 'awards'}">Награды</router-link></li>
                <li v-bind:class="this.$route.name == 'statistic' ? 'is-active' : ''"><router-link :to="{name: 'statistic'}">Статистика</router-link></li>
              </ul>
            </div>
            <router-view :user="currentUser"></router-view>
          </div>
          <div class="column">
            <Profile v-bind:user="currentUser"/>
          </div>
        </div>
      </div>
    </div>

    <div class="game-chat">
      <ChatPanel v-bind:user="currentUser" />
    </div>
  </div>
</template>

<script>
import Profile from './components/Profile'
import ChatPanel from './components/chat/ChatPanel'
import UserService from './services/UserService'
import { USER_CHANNEL, USER_CHANNEL_NAME } from './channels/user_channel'

export default {
  components: {
    Profile,
    ChatPanel,
  },
  channels: {
    UserChannel: {
      received (data) {
        this.handleCableMessage(data)
      },
    },
  },
  data: function () {
    return {
      currentUser: {},
      pollTimer: null,
    }
  },
  created() {
    this.loadInitData()
    this.$cable.subscribe(USER_CHANNEL, USER_CHANNEL_NAME)
    this.$root.$on('user-balance-changed', this.loadInitData)
  },
  beforeDestroy() {
    this.$cable.unsubscribe(USER_CHANNEL_NAME)
    this.$root.$off('user-balance-changed', this.loadInitData)
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
    }
  },
  methods: {
    async loadInitData() {
      const resp = await UserService.me()
      this.currentUser = resp.data

      if (this.pollTimer) {
        clearTimeout(this.pollTimer)
      }
      this.pollTimer = setTimeout(() => {
        this.loadInitData()
      }, 30000)
    },
    handleCableMessage(data) {
      if (data.type === 'learning_finished') {
        const skillName = data.skill?.name || 'навык'
        this.$buefy.toast.open({
          message: `Навык «${skillName}» изучен`,
          type: 'is-success',
          duration: 5000,
        })

        this.loadInitData()
        this.$root.$emit('learning-finished', data)
        return
      }

      if (data.type === 'location_changed') {
        this.loadInitData()
        this.$root.$emit('location-changed', data)
        return
      }

      if (data.type === 'new_message') {
        this.$root.$emit('chat-message', data.message)
        return
      }

      if (data.type === 'private_chat_opened') {
        this.$root.$emit('private-chat-opened', data.chat_room)
      }
    },
  },
}
</script>

<style scoped>
  a {
    text-decoration: none;
  }
  .tabs.is-small {
    margin-top: -20px;
  }
</style>

<style>
  .game-shell {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .game-main {
    flex: 3;
    min-height: 0;
    overflow-y: auto;
  }

  .game-chat {
    flex: 2;
    min-height: 0;
  }
</style>
